import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import bnCommon from './locales/bn/common.json';

const resources = {
  en: {
    common: enCommon,
  },
  bn: {
    common: bnCommon,
  },
};

const storedLanguage = localStorage.getItem('app-language');
const initialLanguage = storedLanguage || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

document.documentElement.lang = initialLanguage;
document.documentElement.dir = 'ltr';
document.body.classList.toggle('lang-bn', initialLanguage === 'bn');

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('app-language', lng);
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'bn' ? 'ltr' : 'ltr';
  document.body.classList.toggle('lang-bn', lng === 'bn');
});

export default i18n;

